export default "__VITE_ASSET__178e6511__"